import { render, staticRenderFns } from "./Almacen.vue?vue&type=template&id=0e6aea9f&scoped=true&"
import script from "./Almacen.vue?vue&type=script&lang=js&"
export * from "./Almacen.vue?vue&type=script&lang=js&"
import style0 from "./Almacen.vue?vue&type=style&index=0&id=0e6aea9f&prod&lang=scss&scoped=true&"
import style1 from "./Almacen.vue?vue&type=style&index=1&id=0e6aea9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6aea9f",
  null
  
)

export default component.exports